// Financials tab redesign — read hooks for the loan's Phoenix Income Pools
// booked ledger (per-period projection over recognized IncomeEvents) and the
// per-period event drill-down. Read-only: no mutations, so no invalidation.

import { useQuery } from "@tanstack/react-query";
import { incomePoolsApi } from "@/api/portfolioAdmin/incomePoolsApi";
import { incomePoolsKeys } from "./incomePoolsKeys";

export function useLoanIncomePools(loanId: string | undefined) {
  return useQuery({
    queryKey: incomePoolsKeys.loan(loanId ?? ""),
    queryFn: () => incomePoolsApi.get(loanId!),
    enabled: !!loanId,
  });
}

export function useIncomePoolPeriodEvents(
  loanId: string | undefined,
  periodStart: string | null,
) {
  return useQuery({
    queryKey: incomePoolsKeys.periodEvents(loanId ?? "", periodStart ?? ""),
    queryFn: () => incomePoolsApi.events(loanId!, periodStart!),
    enabled: !!loanId && !!periodStart,
  });
}
